import React from 'react';
import Cookies from 'js-cookie';
import {
	Row, Col, Input, Button, message,
	Select, Spin, Form, Checkbox, Space, Tooltip, DatePicker, Tag,
} from 'antd';
import {
	SearchOutlined, PrinterOutlined, FilePdfOutlined,
} from '@ant-design/icons';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { connect } from 'react-redux';
import {
	initHandler, ajaxViewHandler, ajaxHandler, setConfig,
} from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import '../../assets/laporan.css';

const JENIS_OPTIONS = [
	{ value: '1', label: 'Discount Pokok PKB Berjalan' },
	{ value: '2', label: 'Pembebasan Denda PKB Berjalan' },
	{ value: '3', label: 'Discount Pokok PKB Tunggakan' },
	{ value: '4', label: 'Pembebasan Denda PKB Tunggakan' },
	{ value: '5', label: 'Discount Pokok SWDKLLJ Berjalan' },
	{ value: '6', label: 'Pembebasan Denda SWDKLLJ Berjalan' },
	{ value: '7', label: 'Discount Pokok SWDKLLJ Tunggakan' },
	{ value: '8', label: 'Pembebasan Denda SWDKLLJ Tunggakan' },
];

const configClass = {
	title: 'Laporan Pemutihan',
	apiUrl: {
		data: 'laporan/api/pemutihan/',
		warna_plat: 'master/api/plat',
		jenis_kendaraan: 'master/api/jenis/kendaraan/',
		payment: 'master/api/payment/?include_deleted=true',
		upt: 'pegawai/api/upt/',
		kabupaten: 'master/api/kabupaten/',
	},
	pageUrl: { cetak: '/laporan/pemutihan' },
};

const config = new Config();
const NAVY     = '#0f2847';
const NAVY_MID = '#1a3a6b';
const PURPLE   = '#6363EC';

class Pemutihan extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.config = new Config();
		this.state = {
			loading: false,
			data: null,
			err: false,
			errMsg: '',

			loadingWarnaPlat: false,      listWarnaPlat: [],
			loadingJenisKendaraan: false, listJenisKendaraan: [],
			loadingPayment: false,        listPayment: [],
			loadingUpt: false,            listUpt: [],
			loadingKabupaten: false,      listKabupaten: [],

			filter: '',
			selectedJenis: [],
			isPrinting: false,
			isExportingPdf: false,

			mulai_dari: '',
			sampai_dengan: '',
			kabupaten_id: '',
			kabId: '',
			isMobile: window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this.loadMasterList();
		this.initKabupatenFromCookie();
		this.setTodayPeriode();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	setTodayPeriode() {
		const today = moment();
		const todayStr = today.format('DD-MM-YYYY');
		this.setState({ mulai_dari: todayStr, sampai_dengan: todayStr });
		setTimeout(() => {
			if (this.formRef.current) {
				this.formRef.current.setFieldsValue({
					mulai_dari_picker: today, sampai_dengan_picker: today,
					mulai_dari: todayStr,     sampai_dengan: todayStr,
				});
			}
		}, 0);
	}

	initKabupatenFromCookie() {
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (!rawCookie) return;
			const parsed = JSON.parse(decodeURIComponent(rawCookie));
			const kabupatenId = parsed.kabupaten;
			if (!kabupatenId) return;
			this.setState({ kabupaten_id: kabupatenId });
			this.getMasterList({
				destination: { stateProgressName: 'loadingUpt', endPoint: configClass.apiUrl.upt + '?kabupaten=' + kabupatenId, stateDestination: 'listUpt' },
				nextDestination: null,
			});
		} catch (err) {
			console.warn('Cookie _upt tidak valid:', err);
		}
	}

	loadMasterList() {
		const rule = [
			{
				destination: { stateProgressName: 'loadingJenisKendaraan', endPoint: configClass.apiUrl.jenis_kendaraan, stateDestination: 'listJenisKendaraan' },
				nextDestination: { stateProgressName: 'loadingWarnaPlat', endPoint: configClass.apiUrl.warna_plat, stateDestination: 'listWarnaPlat', next: null },
			},
			{
				destination: { stateProgressName: 'loadingPayment', endPoint: configClass.apiUrl.payment, stateDestination: 'listPayment' },
				nextDestination: { stateProgressName: 'loadingKabupaten', endPoint: configClass.apiUrl.kabupaten, stateDestination: 'listKabupaten', next: null },
			},
		];
		this.setState({ errComponent: false });
		rule.forEach((item, idx) => this.getMasterList(item, idx === rule.length - 1));
	}

	async getMasterList(rule, isFinal = false) {
		const { destination, nextDestination } = rule;
		this.setState({ [destination.stateProgressName]: true });
		this.props.ajaxViewHandler('get', destination.endPoint)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					if (data.count != null) {
						const cur = this.state[destination.stateDestination];
						const newState = (!cur.length || destination.stateProgressName.includes('_searching'))
							? data
							: { count: data.count, next: data.next, previous: data.previous, results: [...cur.results, ...data.results] };
						this.setState({ [destination.stateDestination]: newState });
					} else if (data.results != null) {
						this.setState({ [destination.stateDestination]: data.results });
					} else {
						this.setState({ [destination.stateDestination]: Array.isArray(data) ? data : [data] });
					}
					if (isFinal && this.props.match?.params?.id != null) { /* noop */ }
				} else {
					this.setState({ errComponent: true });
				}
				this.setState({ [destination.stateProgressName]: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
				this.setState({ [destination.stateProgressName]: false });
			});
		if (nextDestination != null) {
			this.getMasterList({ destination: { stateProgressName: nextDestination.stateProgressName, endPoint: nextDestination.endPoint, stateDestination: nextDestination.stateDestination }, nextDestination: nextDestination.next });
		}
	}

	generateSelect(stateName, url, key, value, keyDisplay = '') {
		let isCookieValid = false;
		let kabupatenId = null;
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (rawCookie) {
				const parsed = JSON.parse(decodeURIComponent(rawCookie));
				kabupatenId = parsed.kabupaten;
				isCookieValid = Boolean(kabupatenId && parsed.id);
			}
		} catch (err) { /* noop */ }

		const listData = this.state['list' + stateName];
		const isPaginated = listData?.count != null;
		const results = isPaginated ? listData.results : (listData || []);
		const stateKey = stateName.toLowerCase() + '_id';
		const selectedId = this.state[stateKey];
		const selectedItem = results.find(item => String(item[key]) == String(selectedId));
		if (selectedId && !selectedItem) return <Spin size="small" />;

		const makeLabel = (item) => keyDisplay ? item[keyDisplay] + ' - ' + item[value] : item[key] + ' - ' + item[value];
		const selectedValue = selectedItem
			? { value: String(selectedItem[key]), label: makeLabel(selectedItem) }
			: undefined;

		return this.state['loading' + stateName] ? <Spin size="small" /> : (
			<Select
				showSearch labelInValue
				defaultValue={selectedValue}
				value={results.length > 0 ? selectedValue : undefined}
				placeholder={'Cari / Pilih ' + stateName}
				disabled={stateName === 'Kabupaten' && isCookieValid
					&& !(this.props.is_superuser || this.props.level_user === 1 || this.props.level_user === 2)}
				optionFilterProp="children"
				optionLabelProp="label"
				allowClear size="small"
				style={{ width: '100%', borderRadius: 8 }}
				onSearch={(val) => {
					const sep = url.includes('?') ? '&' : '?';
					const endPoint = stateName === 'Upt'
						? `${url}${sep}kabupaten=${this.state.kabupaten_id}&search=${val}`
						: `${url}${sep}search=${val}`;
					this.getMasterList({ destination: { stateProgressName: 'loading' + stateName + '_searching', endPoint, stateDestination: 'list' + stateName }, nextDestination: null });
				}}
				onPopupScroll={(e) => {
					e.persist();
					const t = e.target;
					if (t.scrollTop + t.offsetHeight >= t.scrollHeight && listData?.next) {
						this.getMasterList({ destination: { stateProgressName: 'loading' + stateName + 'Paging', endPoint: listData.next, stateDestination: 'list' + stateName }, nextDestination: null });
					}
				}}
				onChange={(valObj) => {
					const val = valObj?.value;
					this.setState({ [stateKey]: val }, () => {
						if (stateName === 'Kabupaten') {
							this.setState({ upt_id: undefined, listUpt: [] }, () => {
								this.getMasterList({ destination: { stateProgressName: 'loadingUpt', endPoint: configClass.apiUrl.upt + '?kabupaten=' + val, stateDestination: 'listUpt' }, nextDestination: null });
							});
						}
					});
				}}
			>
				{this.state['loading' + stateName + '_searching'] && <Select.Option value=""><Spin size="small" /></Select.Option>}
				{results.map((item) => (
					<Select.Option key={item[key]} value={item[key]} label={makeLabel(item)}>
						{makeLabel(item)}
					</Select.Option>
				))}
				{listData?.next && <Select.Option value=""><Spin size="small" /></Select.Option>}
			</Select>
		);
	}

	handleSubmitDetail = (values) => {
		let kabupatenId = null;
		let isCookieValid = false;
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (rawCookie) {
				const parsed = JSON.parse(decodeURIComponent(rawCookie));
				kabupatenId = parsed.kabupaten;
				isCookieValid = Boolean(kabupatenId && parsed.id);
			}
		} catch (err) { console.warn('Cookie _upt tidak valid atau tidak ditemukan:', err); }

		let filter = '';
		if (isCookieValid) {
			filter += (filter === '' ? '?' : '&') + 'kabupaten=' + encodeURIComponent(this.state.kabupaten_id);
		}
		for (let key in values) {
			if (key.endsWith('_picker')) continue;
			let val = values[key];
			if (val != null) {
				if (typeof val === 'object' && val !== null && 'value' in val) val = val.value;
				filter += (filter === '' ? '?' : '&') + key + '=' + encodeURIComponent(val);
			}
		}
		if (this.state.selectedJenis.length > 0) {
			filter += (filter === '' ? '?' : '&') + 'jenis_pemutihan=' + encodeURIComponent(this.state.selectedJenis.join(','));
		}
		this.setState({ filter });
		this.getData(filter);
	};

	async getData(filter) {
		message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
		this.setState({ loading: true, err: false, data: null });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + filter)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({ loading: false, data, err: false });
					const pesan = data?.data?.[0]?.message;
					if (data?.data?.[0]?.status == 1) message.success({ content: pesan, duration: 5, key: 'toast' });
					if (data?.data?.[0]?.status == 0) message.warning({ content: pesan, duration: 5, key: 'toast' });
				} else {
					this.setState({ loading: false, data: null, err: true, errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat laporan', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				this.setState({ loading: false, data: null, err: true, errMsg: 'unknown response' });
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	getColFlags() {
		const d0 = this.state.data?.data?.[0];
		const selJenis = d0?.selected_jenis ?? [];
		const showAll = selJenis.length === 0;
		const col = {
			pokokPkb:          showAll || selJenis.includes('1'),
			dendaPkb:          showAll || selJenis.includes('2'),
			pokokTunggakPkb:   showAll || selJenis.includes('3'),
			dendaTunggakPkb:   showAll || selJenis.includes('4'),
			opsenDendaPkb:     showAll || selJenis.includes('2'),
			opsenPokokTunggak: showAll || selJenis.includes('3'),
			opsenDendaTunggak: showAll || selJenis.includes('4'),
			pokokSwdkllj:      showAll || selJenis.includes('5'),
			dendaSwdkllj:      showAll || selJenis.includes('6'),
			pokokTunggakSwd:   showAll || selJenis.includes('7'),
			dendaTunggakSwd:   showAll || selJenis.includes('8'),
		};
		const discountCols  = [col.pokokPkb, col.pokokTunggakPkb, col.opsenPokokTunggak, col.pokokSwdkllj, col.pokokTunggakSwd].filter(Boolean).length;
		const pkbCols       = [col.dendaPkb, col.dendaTunggakPkb].filter(Boolean).length;
		const opsenCols     = [col.opsenDendaPkb, col.opsenDendaTunggak].filter(Boolean).length;
		const swdCols       = [col.dendaSwdkllj, col.dendaTunggakSwd].filter(Boolean).length;
		const dibebaskanCols = discountCols + pkbCols + opsenCols + swdCols;
		const totalCols      = 16 + dibebaskanCols;
		return { d0, col, discountCols, pkbCols, opsenCols, swdCols, dibebaskanCols, totalCols };
	}

	handlePrint = () => {
		const printEl = document.getElementById('pemutihan-print-area');
		if (!printEl) return;
		this.setState({ isPrinting: true });
		const parent  = printEl.parentNode;
		const nextSib = printEl.nextSibling;
		printEl.style.display = 'block';
		document.body.appendChild(printEl);
		const siblings = Array.from(document.body.children).filter(el => el !== printEl);
		siblings.forEach(el => { el.style.display = 'none'; });
		window.print();
		siblings.forEach(el => { el.style.display = ''; });
		if (nextSib) parent.insertBefore(printEl, nextSib);
		else parent.appendChild(printEl);
		printEl.style.display = '';
		this.setState({ isPrinting: false });
	};

	handleExportPdf = () => {
		this.setState({ isExportingPdf: true });
		try {
			const { d0, col, discountCols, pkbCols, opsenCols, swdCols, dibebaskanCols } = this.getColFlags();
			const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
			const pw = doc.internal.pageSize.width;
			const ph = doc.internal.pageSize.height;
			const C_NAVY = [23, 42, 75]; const C_BLUE = [30, 80, 160];
			const C_TEAL = [14, 120, 100]; const C_PURP = [120, 30, 100]; const C_RED = [170, 40, 40];
			const title = d0?.pemutihan_title ?? 'LAPORAN POKOK PKB DAN DENDA YANG DIBERIKAN PENGHAPUSAN';
			let y = 13;
			doc.setFontSize(11); doc.setFont(undefined, 'bold');
			const titleLines = doc.splitTextToSize(title, pw - 20);
			doc.text(titleLines, pw / 2, y, { align: 'center' });
			y += titleLines.length * 6;
			doc.setFontSize(8.5); doc.setFont(undefined, 'normal');
			if (d0?.title_kab) { doc.text(`UPTPPD ${d0.title_kab.toUpperCase()}`, pw / 2, y, { align: 'center' }); y += 5; }
			if (d0?.tgl_cari)  { doc.text(`TANGGAL ${d0.tgl_cari.toUpperCase()}`, pw / 2, y, { align: 'center' }); y += 5; }
			doc.setDrawColor(...C_NAVY); doc.setLineWidth(0.4); doc.line(10, y, pw - 10, y); y += 3;
			const hCell = (content, color, extra = {}) => ({
				content,
				styles: { fillColor: color, textColor: 255, fontStyle: 'bold', halign: 'center', valign: 'middle', fontSize: 6, cellPadding: { top: 1.5, right: 1.5, bottom: 1.5, left: 1.5 } },
				...extra,
			});
			const colDefs = [
				{ dataKey: 'no' }, { dataKey: 'kendaraan' }, { dataKey: 'tanggal_bayar' }, { dataKey: 'masa_berlaku' },
				{ dataKey: 'warna_plat' }, { dataKey: 'jenis_kendaraan' }, { dataKey: 'upt_asal' }, { dataKey: 'upt_bayar' },
				{ dataKey: 'pokok_pkb' }, { dataKey: 'opsen_pokok_pkb' }, { dataKey: 'tunggakan_pokok_pkb' }, { dataKey: 'opsen_tunggakan_pokok_pkb' },
				{ dataKey: 'pokok_swdkllj' }, { dataKey: 'denda_swkllj' }, { dataKey: 'tunggakan_pokok_swdkllj' },
			];
			if (col.pokokPkb)          colDefs.push({ dataKey: 'discount_pokok_pkb' });
			if (col.pokokTunggakPkb)   colDefs.push({ dataKey: 'discount_tunggakan_pokok_pkb' });
			if (col.opsenPokokTunggak) colDefs.push({ dataKey: 'discount_tunggakan_opsen_pokok_pkb' });
			if (col.pokokSwdkllj)      colDefs.push({ dataKey: 'discount_pokok_swdkllj' });
			if (col.pokokTunggakSwd)   colDefs.push({ dataKey: 'discount_tunggakan_pokok_swdkllj' });
			if (col.dendaPkb)          colDefs.push({ dataKey: 'discount_denda_pkb' });
			if (col.dendaTunggakPkb)   colDefs.push({ dataKey: 'discount_tunggakan_denda_pkb' });
			if (col.opsenDendaPkb)     colDefs.push({ dataKey: 'discount_denda_opsen_pkb' });
			if (col.opsenDendaTunggak) colDefs.push({ dataKey: 'discount_tunggakan_opsen_denda_pkb' });
			if (col.dendaSwdkllj)      colDefs.push({ dataKey: 'discount_denda_swdkllj' });
			if (col.dendaTunggakSwd)   colDefs.push({ dataKey: 'discount_tunggakan_denda_swdkllj' });
			const hRow1 = [
				hCell('NO', C_NAVY, { rowSpan: 3 }), hCell('NOPOL / NAMA / ALAMAT / NO HP', C_NAVY, { rowSpan: 3 }),
				hCell('TGL\nPEMBAYARAN', C_NAVY, { rowSpan: 3 }), hCell('MASA BERLAKU\n/ KET TUNGGAK', C_NAVY, { rowSpan: 3 }),
				hCell('WRN\nPLAT', C_NAVY, { rowSpan: 3 }), hCell('JNS\nKEND', C_NAVY, { rowSpan: 3 }),
				hCell('LOKASI', C_NAVY, { rowSpan: 2, colSpan: 2 }), hCell('JUMLAH YANG DITERIMA (Rp)', C_BLUE, { colSpan: 7 }),
			];
			if (dibebaskanCols > 0) hRow1.push(hCell('JUMLAH YANG DIBEBASKAN (Rp)', C_NAVY, { colSpan: dibebaskanCols }));
			const hRow2 = [
				hCell('POKOK PKB\nBERJALAN', C_BLUE, { colSpan: 2 }), hCell('POKOK PKB\nTUNGGAK', C_BLUE, { colSpan: 2 }), hCell('SWDKLLJ', C_BLUE, { colSpan: 3 }),
			];
			if (discountCols > 0) hRow2.push(hCell('DISCOUNT',            C_TEAL, { colSpan: discountCols }));
			if (pkbCols > 0)      hRow2.push(hCell('PEMBEBASAN\nPKB',    C_PURP, { colSpan: pkbCols }));
			if (opsenCols > 0)    hRow2.push(hCell('PEMBEBASAN\nOPSEN',  C_PURP, { colSpan: opsenCols }));
			if (swdCols > 0)      hRow2.push(hCell('PEMBEBASAN\nSWDKLLJ', C_RED,  { colSpan: swdCols }));
			const hRow3 = [
				hCell('UPT\nASAL', C_NAVY), hCell('BAYAR\nDI', C_NAVY),
				hCell('PKB', C_BLUE), hCell('OPSEN', C_BLUE), hCell('PKB', C_BLUE), hCell('OPSEN\nPKB', C_BLUE),
				hCell('POKOK\nBERJALAN', C_BLUE), hCell('DENDA\nBERJALAN', C_BLUE), hCell('POKOK\nTUNGGAK', C_BLUE),
			];
			if (col.pokokPkb)          hRow3.push(hCell('PKB\nBERJALAN',       C_TEAL));
			if (col.pokokTunggakPkb)   hRow3.push(hCell('PKB\nTUNGGAK',        C_TEAL));
			if (col.opsenPokokTunggak) hRow3.push(hCell('OPSEN\nPKB',          C_TEAL));
			if (col.pokokSwdkllj)      hRow3.push(hCell('SWD\nBERJALAN',       C_TEAL));
			if (col.pokokTunggakSwd)   hRow3.push(hCell('SWD\nTUNGGAK',        C_TEAL));
			if (col.dendaPkb)          hRow3.push(hCell('DENDA\nBERJALAN',     C_PURP));
			if (col.dendaTunggakPkb)   hRow3.push(hCell('DENDA\nTUNGGAK',      C_PURP));
			if (col.opsenDendaPkb)     hRow3.push(hCell('DENDA\nBERJALAN',     C_PURP));
			if (col.opsenDendaTunggak) hRow3.push(hCell('DENDA\nTUNGGAK',      C_PURP));
			if (col.dendaSwdkllj)      hRow3.push(hCell('DENDA\nBERJALAN',     C_RED));
			if (col.dendaTunggakSwd)   hRow3.push(hCell('DENDA\nTUNGGAK',      C_RED));
			const rows = this.state.data.data.map((item, idx) => ({
				no: idx + 1,
				kendaraan: `${item.nomor_polisi ?? ''}\n${item.nama ?? ''}\n${item.alamat ?? ''}\n${item.no_hp ?? ''}`,
				tanggal_bayar: col.pokokPkb ? `${item.tanggal_bayar ?? ''}\n${item.selisih_bayar_notice ?? ''}` : (item.tanggal_bayar ?? ''),
				masa_berlaku: `${item.sd_notice ?? ''}\n${item.jumlah_tunggakan ?? ''}`,
				tunggakan_pokok_pkb: item.tunggakan_pokok_pkb ?? '', opsen_tunggakan_pokok_pkb: item.opsen_tunggakan_pokok_pkb ?? '',
				warna_plat: item.warna_plat ?? '', jenis_kendaraan: item.jenis_kendaraan ?? '',
				upt_asal: item.upt_asal ?? '', upt_bayar: item.upt_bayar ?? '',
				pokok_pkb: item.pokok_pkb ?? '', opsen_pokok_pkb: item.opsen_pokok_pkb ?? '',
				pokok_swdkllj: item.pokok_swdkllj ?? '', denda_swkllj: item.denda_swkllj ?? '', tunggakan_pokok_swdkllj: item.tunggakan_pokok_swdkllj ?? '',
				discount_pokok_pkb: item.discount_pokok_pkb ?? '', discount_tunggakan_pokok_pkb: item.discount_tunggakan_pokok_pkb ?? '',
				discount_tunggakan_opsen_pokok_pkb: item.discount_tunggakan_opsen_pokok_pkb ?? '', discount_pokok_swdkllj: item.discount_pokok_swdkllj ?? '',
				discount_tunggakan_pokok_swdkllj: item.discount_tunggakan_pokok_swdkllj ?? '', discount_denda_pkb: item.discount_denda_pkb ?? '',
				discount_tunggakan_denda_pkb: item.discount_tunggakan_denda_pkb ?? '', discount_denda_opsen_pkb: item.discount_denda_opsen_pkb ?? '',
				discount_tunggakan_opsen_denda_pkb: item.discount_tunggakan_opsen_denda_pkb ?? '', discount_denda_swdkllj: item.discount_denda_swdkllj ?? '',
				discount_tunggakan_denda_swdkllj: item.discount_tunggakan_denda_swdkllj ?? '',
			}));
			const colStyles = {
				no: { cellWidth: 7, halign: 'center' }, kendaraan: { cellWidth: 58 },
				tanggal_bayar: { cellWidth: 16, halign: 'center', overflow: 'linebreak' },
				masa_berlaku: { cellWidth: 26, halign: 'center', overflow: 'linebreak' },
				warna_plat: { cellWidth: 11, halign: 'center' }, jenis_kendaraan: { cellWidth: 14, halign: 'center' },
				upt_asal: { cellWidth: 19, halign: 'center' }, upt_bayar: { cellWidth: 19, halign: 'center' },
			};
			['pokok_pkb','opsen_pokok_pkb','tunggakan_pokok_pkb','opsen_tunggakan_pokok_pkb','pokok_swdkllj','denda_swkllj','tunggakan_pokok_swdkllj',
			 'discount_pokok_pkb','discount_tunggakan_pokok_pkb','discount_tunggakan_opsen_pokok_pkb','discount_pokok_swdkllj','discount_tunggakan_pokok_swdkllj',
			 'discount_denda_pkb','discount_tunggakan_denda_pkb','discount_denda_opsen_pkb','discount_tunggakan_opsen_denda_pkb','discount_denda_swdkllj','discount_tunggakan_denda_swdkllj',
			].forEach(k => { colStyles[k] = { halign: 'right' }; });
			doc.autoTable({
				startY: y, columns: colDefs, head: [hRow1, hRow2, hRow3], body: rows,
				styles: { fontSize: 6, cellPadding: { top: 1.5, right: 2, bottom: 1.5, left: 2 }, overflow: 'linebreak', lineColor: [200, 210, 230], lineWidth: 0.2 },
				tableLineWidth: 0.3, tableLineColor: [23, 42, 75], rowPageBreak: 'avoid', headStyles: { minCellHeight: 7 },
				alternateRowStyles: { fillColor: [246, 249, 255] }, columnStyles: colStyles, margin: { top: 8, right: 8, bottom: 10, left: 8 },
				didParseCell: (data) => {
					if (data.column.dataKey === 'kendaraan' && data.section === 'body') {
						data.cell.text = [];
						const parts = (data.cell.raw ?? '').toString().split('\n');
						doc.setFontSize(5.5);
						const alamatLines = doc.splitTextToSize(parts[2] ?? '', 54);
						data.cell.styles.minCellHeight = Math.max(18, 4 + 4 + 3.5 + (alamatLines.length * 3.2) + 3.5 + 2);
					}
				},
				didDrawCell: (data) => {
					if (data.column.dataKey !== 'kendaraan' || data.section !== 'body') return;
					const parts = (data.cell.raw ?? '').toString().split('\n');
					const x = data.cell.x + 2; let cy = data.cell.y + 4;
					doc.setFontSize(6.5); doc.setFont(undefined, 'bold'); doc.setTextColor(...C_NAVY);
					doc.text(parts[0] ?? '', x, cy); cy += 4;
					doc.setFontSize(6); doc.setFont(undefined, 'normal'); doc.setTextColor(30, 30, 30);
					doc.text(parts[1] ?? '', x, cy); cy += 3.5;
					const maxW = data.cell.width - 4;
					doc.setFontSize(5.5); doc.setTextColor(120, 120, 120);
					const alamatLines = doc.splitTextToSize(parts[2] ?? '', maxW);
					alamatLines.forEach((line, li) => { doc.text(line, x, cy + li * 3.2); });
					cy += alamatLines.length * 3.2;
					doc.setFontSize(5.5); doc.setFont(undefined, 'normal'); doc.setTextColor(80, 80, 80);
					if (parts[3]) doc.text(parts[3], x, cy);
					doc.setTextColor(0);
				},
				didDrawPage: (data) => {
					doc.setFontSize(6.5); doc.setTextColor(140);
					doc.text(`Halaman ${data.pageNumber}`, pw - 8, ph - 5, { align: 'right' });
					doc.text(`Dicetak: ${new Date().toLocaleString('id-ID')}`, 8, ph - 5);
					doc.setTextColor(0);
				},
			});
			doc.save(`laporan-pemutihan-${new Date().toISOString().slice(0, 10)}.pdf`);
		} catch (err) {
			message.error({ content: 'Gagal export PDF: ' + err.message, key: 'pdf-err', duration: 4 });
		} finally {
			this.setState({ isExportingPdf: false });
		}
	};

	renderTabel() {
		const { d0, col, discountCols, pkbCols, opsenCols, swdCols, dibebaskanCols, totalCols } = this.getColFlags();
		return (
			<div className="kertas-laporan">
				<table className="laporan-table" cellPadding="5" border="1" style={{ width: '100%' }}>
					<tr style={{ border: 'none', borderBottom: '1px solid #000' }}>
						<th colSpan={totalCols}>
							<div className="judul-laporan-pemutihan" style={{ borderBottom: 'double 5px #000' }}>
								{d0?.pemutihan_title ?? 'LAPORAN POKOK PKB DAN DENDA YANG DIBERIKAN PENGHAPUSAN'}
								{d0?.title_kab && <><br />UPTPPD {d0.title_kab.toUpperCase()}</>}
								{d0?.tgl_cari && <><br />TANGGAL {d0.tgl_cari.toUpperCase()}</>}
								<br />
							</div>
						</th>
					</tr>
					<tr>
						<th rowSpan={3} style={{ width: 50 }}>NO</th>
						<th rowSpan={3} style={{ width: 100 }}>NOPOL</th>
						<th rowSpan={3} style={{ width: 420 }}>NAMA / ALAMAT / NO HP</th>
						<th rowSpan={3} style={{ width: 110 }}>TGL PEMBAYARAN</th>
						<th rowSpan={3} style={{ width: 160 }}>MASA BERLAKU / KET TUNGGAKAN</th>
						<th rowSpan={3} style={{ width: 90 }}>WARNA PLAT</th>
						<th rowSpan={3} style={{ width: 110 }}>JENIS KENDARAAN</th>
						<th rowSpan={2} colSpan={2} style={{ width: 110 }}>LOKASI</th>
						<th colSpan={7} style={{ width: 560 }}>JUMLAH YANG DITERIMA (Rp)</th>
						{dibebaskanCols > 0 && <th colSpan={dibebaskanCols}>JUMLAH YANG DIBEBASKAN (Rp)</th>}
					</tr>
					<tr>
						<th colSpan={2}>POKOK PKB BERJALAN</th>
						<th colSpan={2}>POKOK PKB TERTUNGGAK</th>
						<th colSpan={3}>SWDKLLJ</th>
						{discountCols > 0 && <th colSpan={discountCols}>DISCOUNT</th>}
						{pkbCols > 0 && <th colSpan={pkbCols}>PEMBEBASAN PKB</th>}
						{opsenCols > 0 && <th colSpan={opsenCols}>PEMBEBASAN OPSEN</th>}
						{swdCols > 0 && <th colSpan={swdCols}>PEMBEBASAN SWDKLLJ</th>}
					</tr>
					<tr>
						<th>UPT</th><th>BAYAR DI</th>
						<th>PKB</th><th>OPSEN</th><th>PKB</th><th>OPSEN</th>
						<th>POKOK BERJALAN</th><th>DENDA BERJALAN</th><th>POKOK TUNGGAK</th>
						{col.pokokPkb && <th>PKB BERJALAN</th>}
						{col.pokokTunggakPkb && <th>PKB TUNGGAK</th>}
						{col.opsenPokokTunggak && <th>OPSEN PKB TUNGGAK</th>}
						{col.pokokSwdkllj && <th>SWD BERJALAN</th>}
						{col.pokokTunggakSwd && <th>SWD TUNGGAK</th>}
						{col.dendaPkb && <th>DENDA BERJALAN</th>}
						{col.dendaTunggakPkb && <th>DENDA TUNGGAK</th>}
						{col.opsenDendaPkb && <th>OPSEN DENDA BERJALAN</th>}
						{col.opsenDendaTunggak && <th>OPSEN DENDA TUNGGAK</th>}
						{col.dendaSwdkllj && <th>DENDA SWD BERJALAN</th>}
						{col.dendaTunggakSwd && <th>DENDA SWD TUNGGAK</th>}
					</tr>
					<tbody>
						{this.state.data.data.map((item, idx) => (
							<tr key={idx}>
								<td style={{ textAlign: 'center' }}>{idx + 1}</td>
								<td style={{ textAlign: 'center' }}>{item.nomor_polisi}</td>
								<td>{item.nama ?? ''}<p>{item.alamat}</p><p style={{ color: '#555', fontSize: '0.85em' }}>{item.no_hp}</p></td>
								<td style={{ textAlign: 'center' }}>
									{item.tanggal_bayar ?? ''}
									{col.pokokPkb && <p style={{ color: '#555', fontSize: '0.85em', marginTop: 2 }}>{item.selisih_bayar_notice}</p>}
								</td>
								<td>{item.sd_notice}<p style={{ color: '#555', fontSize: '0.85em', marginTop: 2 }}>{item.jumlah_tunggakan}</p></td>
								<td style={{ textAlign: 'center' }}>{item.warna_plat}</td>
								<td style={{ textAlign: 'center' }}>{item.jenis_kendaraan}</td>
								<td style={{ textAlign: 'right' }}>{item.upt_asal ?? ''}</td>
								<td style={{ textAlign: 'right' }}>{item.upt_bayar ?? ''}</td>
								<td style={{ textAlign: 'right' }}>{item.pokok_pkb ?? ''}</td>
								<td style={{ textAlign: 'right' }}>{item.opsen_pokok_pkb ?? ''}</td>
								<td style={{ textAlign: 'right' }}>{item.tunggakan_pokok_pkb ?? ''}</td>
								<td style={{ textAlign: 'right' }}>{item.opsen_tunggakan_pokok_pkb ?? ''}</td>
								<td style={{ textAlign: 'right' }}>{item.pokok_swdkllj ?? ''}</td>
								<td style={{ textAlign: 'right' }}>{item.denda_swkllj ?? ''}</td>
								<td style={{ textAlign: 'right' }}>{item.tunggakan_pokok_swdkllj ?? ''}</td>
								{col.pokokPkb && <td style={{ textAlign: 'right' }}>{item.discount_pokok_pkb ?? ''}</td>}
								{col.pokokTunggakPkb && <td style={{ textAlign: 'right' }}>{item.discount_tunggakan_pokok_pkb ?? ''}</td>}
								{col.opsenPokokTunggak && <td style={{ textAlign: 'right' }}>{item.discount_tunggakan_opsen_pokok_pkb ?? ''}</td>}
								{col.pokokSwdkllj && <td style={{ textAlign: 'right' }}>{item.discount_pokok_swdkllj ?? ''}</td>}
								{col.pokokTunggakSwd && <td style={{ textAlign: 'right' }}>{item.discount_tunggakan_pokok_swdkllj ?? ''}</td>}
								{col.dendaPkb && <td style={{ textAlign: 'right' }}>{item.discount_denda_pkb ?? ''}</td>}
								{col.dendaTunggakPkb && <td style={{ textAlign: 'right' }}>{item.discount_tunggakan_denda_pkb ?? ''}</td>}
								{col.opsenDendaPkb && <td style={{ textAlign: 'right' }}>{item.discount_denda_opsen_pkb ?? ''}</td>}
								{col.opsenDendaTunggak && <td style={{ textAlign: 'right' }}>{item.discount_tunggakan_opsen_denda_pkb ?? ''}</td>}
								{col.dendaSwdkllj && <td style={{ textAlign: 'right' }}>{item.discount_denda_swdkllj ?? ''}</td>}
								{col.dendaTunggakSwd && <td style={{ textAlign: 'right' }}>{item.discount_tunggakan_denda_swdkllj ?? ''}</td>}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	render() {
		const { loading, data, err, selectedJenis, isPrinting, isExportingPdf, isMobile } = this.state;
		const hasData = data?.data?.[0]?.status == 1;

		const labelF = (txt) => (
			<span style={{ fontSize: 11, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: .5 }}>{txt}</span>
		);

		return (
			<>
				<div>
					<Helmet>
						<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
						<style>{`
							.pemutihan-wrap .ant-form-item-label > label { font-weight: 600; color: #475569; font-size: 11px; }
							.pemutihan-wrap .ant-picker, .pemutihan-wrap .ant-select-selector, .pemutihan-wrap .ant-input { border-radius: 8px !important; }
							#pemutihan-print-area { display: none; }
							@media print { #pemutihan-print-area { display: block !important; } }
						`}</style>
					</Helmet>

					<div className="pemutihan-wrap">
						<Row gutter={[0, 16]}>

							{/* ══ FILTER PANEL ══ */}
							<Col span={24}>
								<div style={{ background: '#fff', borderRadius: 14, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 12px rgba(15,40,71,0.07)' }}>

									{/* Header dark navy */}
									<div style={{ background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`, padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
										<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
											<div style={{ width: 38, height: 38, background: 'rgba(251,191,36,0.15)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 19 }}>🎫</div>
											<div>
												<div style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>{configClass.title}</div>
												<div style={{ fontSize: 11, color: '#94a3b8', marginTop: 1 }}>Laporan pokok dan denda PKB / SWDKLLJ yang diberikan penghapusan / pemutihan</div>
											</div>
										</div>
										{hasData && (
											<Space size={8}>
												<Tooltip title="Cetak laporan">
													<Button icon={<PrinterOutlined />} loading={isPrinting} disabled={isExportingPdf}
														onClick={this.handlePrint}
														style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)', color: '#fff', fontWeight: 600 }}>
														{!isMobile && 'Cetak'}
													</Button>
												</Tooltip>
												<Tooltip title="Unduh sebagai PDF">
													<Button icon={<FilePdfOutlined />} loading={isExportingPdf} disabled={isPrinting}
														onClick={this.handleExportPdf}
														style={{ borderRadius: 8, background: '#c0392b', border: 'none', color: '#fff', fontWeight: 600 }}>
														{!isMobile && 'Export PDF'}
													</Button>
												</Tooltip>
											</Space>
										)}
									</div>

									{/* Filter form */}
									<Form
										layout="vertical" name="fdata" ref={this.formRef} size="small" disabled={loading}
										onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
										style={{ padding: '18px 20px 14px' }}
									>
										{/* Grid filter utama */}
										<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '0 16px' }}>
											<Form.Item name="kabupaten" label={labelF('Kabupaten')} style={{ marginBottom: 10 }}>
												{this.generateSelect('Kabupaten', configClass.apiUrl.kabupaten, 'id', 'name')}
											</Form.Item>
											<Form.Item name="upt" label={labelF('UPT')} style={{ marginBottom: 10 }}>
												{this.generateSelect('Upt', configClass.apiUrl.upt, 'id', 'nama', 'id')}
											</Form.Item>
											<Form.Item name="jenis_kendaraan" label={labelF('Jenis Kendaraan')} style={{ marginBottom: 10 }}>
												{this.generateSelect('JenisKendaraan', configClass.apiUrl.jenis_kendaraan, 'id', 'nama', 'kode')}
											</Form.Item>
											<Form.Item name="warna_plat" label={labelF('Warna Plat')} style={{ marginBottom: 10 }}>
												{this.generateSelect('WarnaPlat', configClass.apiUrl.warna_plat, 'id', 'nama', 'kode')}
											</Form.Item>
											<Form.Item name="roda" label={labelF('Jumlah Roda')} style={{ marginBottom: 10 }}>
												<Input placeholder="cth: 2" size="small" style={{ borderRadius: 8 }} />
											</Form.Item>
											<Form.Item name="payment_type" label={labelF('Jenis Pembayaran')} style={{ marginBottom: 10 }}>
												{this.generateSelect('Payment', configClass.apiUrl.payment, 'id', 'nama', 'kode')}
											</Form.Item>
											<Form.Item name="mulai_dari_picker" label={labelF('Periode Mulai')} style={{ marginBottom: 10 }}>
												<DatePicker placeholder="dd-mm-yyyy" format="DD-MM-YYYY" style={{ width: '100%', borderRadius: 8 }}
													onChange={(_, s) => { this.formRef.current.setFieldsValue({ mulai_dari: s }); this.setState({ mulai_dari: s }); }}
												/>
											</Form.Item>
											<Form.Item name="sampai_dengan_picker" label={labelF('Sampai Dengan')} style={{ marginBottom: 10 }}>
												<DatePicker placeholder="dd-mm-yyyy" format="DD-MM-YYYY" style={{ width: '100%', borderRadius: 8 }}
													onChange={(_, s) => { this.formRef.current.setFieldsValue({ sampai_dengan: s }); this.setState({ sampai_dengan: s }); }}
												/>
											</Form.Item>
										</div>

										{/* Hidden fields */}
										<Form.Item name="mulai_dari"    style={{ display: 'none' }}><Input type="hidden" /></Form.Item>
										<Form.Item name="sampai_dengan" style={{ display: 'none' }}><Input type="hidden" /></Form.Item>

										{/* Jenis Pemutihan */}
										<Form.Item label={labelF('Jenis Pemutihan')} style={{ marginBottom: 12 }}>
											<div style={{ border: '1px solid #e2e8f0', borderRadius: 10, padding: '12px 16px', background: '#fafbfe' }}>
												<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, paddingBottom: 8, borderBottom: '1px solid #e8ecf5' }}>
													<Checkbox
														indeterminate={selectedJenis.length > 0 && selectedJenis.length < JENIS_OPTIONS.length}
														checked={selectedJenis.length === JENIS_OPTIONS.length}
														onChange={(e) => this.setState({ selectedJenis: e.target.checked ? JENIS_OPTIONS.map(o => o.value) : [] })}
													>
														<span style={{ fontWeight: 700, fontSize: 12, color: NAVY }}>Pilih Semua</span>
													</Checkbox>
													{selectedJenis.length > 0 && (
														<span onClick={() => this.setState({ selectedJenis: [] })}
															style={{ color: PURPLE, cursor: 'pointer', fontSize: 11, fontWeight: 600, userSelect: 'none' }}>
															Reset
														</span>
													)}
												</div>
												<Row gutter={16}>
													<Col span={12}>
														<div style={{ fontSize: 10, fontWeight: 700, color: '#1890ff', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8 }}>PKB</div>
														{JENIS_OPTIONS.slice(0, 4).map(opt => (
															<div key={opt.value} style={{ marginBottom: 6 }}>
																<Checkbox checked={selectedJenis.includes(opt.value)}
																	onChange={(e) => {
																		const next = e.target.checked ? [...selectedJenis, opt.value] : selectedJenis.filter(v => v !== opt.value);
																		this.setState({ selectedJenis: next });
																	}}>
																	<span style={{ fontSize: 12 }}>{opt.label}</span>
																</Checkbox>
															</div>
														))}
													</Col>
													<Col span={12} style={{ borderLeft: '1px dashed #e2e8f0', paddingLeft: 16 }}>
														<div style={{ fontSize: 10, fontWeight: 700, color: '#52c41a', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8 }}>SWDKLLJ</div>
														{JENIS_OPTIONS.slice(4).map(opt => (
															<div key={opt.value} style={{ marginBottom: 6 }}>
																<Checkbox checked={selectedJenis.includes(opt.value)}
																	onChange={(e) => {
																		const next = e.target.checked ? [...selectedJenis, opt.value] : selectedJenis.filter(v => v !== opt.value);
																		this.setState({ selectedJenis: next });
																	}}>
																	<span style={{ fontSize: 12 }}>{opt.label}</span>
																</Checkbox>
															</div>
														))}
													</Col>
												</Row>
												<div style={{ marginTop: 8, paddingTop: 6, borderTop: '1px dashed #e2e8f0', fontSize: 11, color: '#94a3b8' }}>
													{selectedJenis.length === 0
														? 'Kosong = tampilkan semua jenis pemutihan'
														: <span style={{ color: PURPLE, fontWeight: 600 }}>{selectedJenis.length} jenis dipilih</span>
													}
												</div>
											</div>
										</Form.Item>

										{/* Action buttons */}
										<div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', paddingTop: 4 }}>
											<Button
												loading={loading} disabled={loading}
												icon={!loading && <SearchOutlined />}
												style={{ borderRadius: 9, height: 36, paddingInline: 22, fontWeight: 700, background: PURPLE, borderColor: PURPLE, color: '#fff' }}
												onClick={() => {
													this.formRef.current.validateFields()
														.then((values) => this.handleSubmitDetail(values))
														.catch(() => {});
												}}
											>
												Lihat Detail
											</Button>
											{hasData && (
												<>
													<Tooltip title="Cetak laporan">
														<Button icon={<PrinterOutlined />} loading={isPrinting} disabled={isExportingPdf}
															onClick={this.handlePrint}
															style={{ borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 600, borderColor: PURPLE, color: PURPLE }}>
															Cetak
														</Button>
													</Tooltip>
													<Tooltip title="Unduh laporan sebagai PDF">
														<Button icon={<FilePdfOutlined />} loading={isExportingPdf} disabled={isPrinting}
															onClick={this.handleExportPdf}
															style={{ borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 600, background: '#c0392b', borderColor: '#c0392b', color: '#fff' }}>
															Export PDF
														</Button>
													</Tooltip>
												</>
											)}
										</div>
									</Form>
								</div>
							</Col>

							{/* ══ LOADING ══ */}
							{loading && (
								<Col span={24}>
									<div style={{ background: '#fff', borderRadius: 14, padding: '36px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
										<Spin size="large" />
										<div style={{ marginTop: 12, color: '#64748b', fontSize: 13 }}>Memproses laporan, mohon tunggu...</div>
									</div>
								</Col>
							)}

							{/* ══ EMPTY ══ */}
							{!data && !loading && !err && (
								<Col span={24}>
									<div style={{ background: '#fff', borderRadius: 14, padding: '48px 24px', textAlign: 'center', border: '1px solid #e2e8f0', color: '#aaa' }}>
										<div style={{ fontSize: 36, marginBottom: 12 }}>🎫</div>
										<div style={{ fontSize: 14 }}>Isi filter dan tekan <b>Lihat Detail</b> untuk menampilkan laporan pemutihan</div>
									</div>
								</Col>
							)}

							{/* ══ ERROR ══ */}
							{err && !loading && (
								<Col span={24}>
									<div style={{ background: '#fff1f0', borderRadius: 14, padding: '36px 24px', textAlign: 'center', border: '1px solid #ffa39e', color: '#cf1322' }}>
										<div style={{ fontSize: 14, fontWeight: 600 }}>Gagal memuat laporan. Coba kembali.</div>
									</div>
								</Col>
							)}

							{/* ══ HASIL ══ */}
							{data && !loading && (
								<Col span={24}>
									<div style={{ background: '#fff', borderRadius: 14, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 10px rgba(15,40,71,0.06)' }}>
										<div style={{ background: '#0f284708', padding: '12px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, borderBottom: '1px solid #0f284722' }}>
											<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
												<span style={{ fontSize: 16 }}>📋</span>
												<span style={{ fontSize: 13, fontWeight: 700, color: NAVY, textTransform: 'uppercase', letterSpacing: .8 }}>Rincian Laporan Pemutihan</span>
											</div>
											{hasData && (
												<Tag style={{ fontSize: 12, padding: '3px 14px', borderRadius: 16, fontWeight: 700, border: 'none', background: '#dcfce7', color: '#15803d' }}>
													✓ {data.data.length - 1} data
												</Tag>
											)}
											{data?.data?.[0]?.status == 0 && (
												<Tag style={{ fontSize: 12, padding: '3px 14px', borderRadius: 16, fontWeight: 700, border: 'none', background: '#fef3c7', color: '#b45309' }}>
													⚠ Tidak ada data
												</Tag>
											)}
										</div>
										{hasData && (
											<div style={{ overflowX: 'auto' }}>
												{this.renderTabel()}
											</div>
										)}
									</div>
								</Col>
							)}
						</Row>
					</div>
				</div>

				{/* Area cetak — tersembunyi di layar, tampil saat window.print() */}
				<div id="pemutihan-print-area">
					{data?.data?.[0]?.status == 1 && this.renderTabel()}
				</div>
			</>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;
export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(Pemutihan);
